// @services/ReportedReview/GetReportedReviewsService.ts
import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'

export interface ClaimedPage {
  id: number
  name: string
  city?: string | null
  state?: string | null
  type?: 'hospital' | 'agency'
  claimId?: number
  claimRequestId?: number
  organizationName?: string
  requesterName?: string
  requesterEmail?: string
  requesterTitle?: string | null
  proofDocumentation?: Record<string, unknown> | null
  auth0UserId?: string
  claimStatus?: 'pending' | 'approved' | 'rejected' | string
  customizationStatus?: string | null
  customization?: any | null
  original?: any | null
  createdAt: string
  reviewedAt?: string | null
}

const normalizeClaimedPage = (item: ClaimedPage, isAgency: boolean): ClaimedPage => {
  const claimRequestId = item.claimRequestId ?? item.claimId
  return {
    ...item,
    type: isAgency ? 'agency' : 'hospital',
    claimRequestId,
    claimId: claimRequestId,
  }
}

export class ClaimedPagesService {
  async getClaimedPages(isAgency: boolean): Promise<ClaimedPage[]> {
    const api = new ScrubstrApiQueryService()
    const data = await api.get<ClaimedPage[]>({
      endpoint: 'admin/claim-pages/claimed-pages',
      params: { isAgency: String(isAgency) },
    })

    // Normalize and ensure we return an array with a `type` property
    return Array.isArray(data) ? data.map((item) => normalizeClaimedPage(item, isAgency)) : []
  }
}
